import { throttle } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import scrollParent from '../../services/scroll-parent';
import Wix from '../../services/wix-sdk-polyfill';
import withDeviceType from '../../hoc/with-device-type';

class ScrollListener extends Component {
  static propTypes = {
    onScroll: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
  };

  componentDidMount() {
    this.props.isMobile ? this.startListeningToInnerScroll() : this.startListeningToOuterScroll();
  }

  componentWillUnmount() {
    this.props.isMobile ?
      scrollParent().removeEventListener('scroll', this.handleInnerScroll) :
      Wix.removeEventListener(Wix.Events.SCROLL, this.handleOuterScroll);
  }

  startListeningToInnerScroll() {
    scrollParent().addEventListener('scroll', this.handleInnerScroll);
  }

  startListeningToOuterScroll() {
    Wix.addEventListener(Wix.Events.SCROLL, this.handleOuterScroll);
  }

  handleInnerScroll = throttle(() =>
    this.props.onScroll({
      scrollTop: scrollParent().scrollTop,
      documentHeight: scrollParent().offsetHeight,
    })
  );

  handleOuterScroll = throttle(scroll => this.props.onScroll(scroll));

  render() {
    return <div/>;
  }
}

export default withDeviceType(ScrollListener);



// WEBPACK FOOTER //
// ./app/components/scroll-listener/scroll-listener.js